webpackJsonp([17979545167704],{

/***/ 1308:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"6 Reasons Why YOU should be a Code Fellow!","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/6-reasons-why-you-should-be-a-code-fellow","createdAt":"2013-11-08T04:11:36.677Z","blogAuthor":{"fields":{"name":"Alec Matias","slug":"blog/author/alec-matias"}},"imageHeader":null}}]},"authorJson":{"name":"Alec Matias","slug":"blog/author/alec-matias","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/alec-matias"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-alec-matias-7f5308a2d9abe9c8bbb7.js